import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

const FcaTimelineItem = ({ item }) => {
  return (
    <AccordionItem
      value={item.id}
      className="border-foreground/10 group relative border-b pl-6 last:border-b-0"
    >
      <span
        className="bg-foreground absolute top-6 -bottom-6 left-1 w-0.5 group-last:hidden"
        aria-hidden="true"
      />
      <span
        className="bg-foreground absolute top-6 left-0 size-2.5 rounded-full"
        aria-hidden="true"
      />
      <AccordionTrigger className="py-3 hover:no-underline">
        <span className="flex flex-col text-left">
          <span className="text-xs font-bold tracking-wide text-[#ff914d] uppercase">
            {item.date}
          </span>
          <span className="text-foreground text-sm font-semibold sm:text-base">
            {item.headline}
          </span>
        </span>
      </AccordionTrigger>
      <AccordionContent>
        <p className="text-foreground/90 mb-3 text-sm leading-relaxed break-words">
          {item.description}
        </p>
        <ul className="space-y-1.5">
          {item.links.map(link => (
            <li key={link.url}>
              <a
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block text-sm font-semibold break-words text-[#ff914d] underline-offset-2 hover:underline"
              >
                {link.label} ↗
              </a>
            </li>
          ))}
        </ul>
      </AccordionContent>
    </AccordionItem>
  )
}

export default FcaTimelineItem
